// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__1fxnY","addWidgetButton":"Header_addWidgetButton__1fC2i","dashboardTabs":"Header_dashboardTabs__3uNDV","active":"Header_active__1a7ny"};